var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"20250410.2"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/online/shop";

import * as Sentry from '@sentry/nextjs';

const SENTRY_MONTIORED_ENVIRONMENTS = {
  'www-sit.spark.co.nz': 'INT01',
  'www-int03.spark.co.nz': 'INT03',
  'www-int05.spark.co.nz': 'INT05',
  'www-staging.spark.co.nz': 'Staging',
  'www.spark.co.nz': 'Production',
};

const environment = SENTRY_MONTIORED_ENVIRONMENTS[window.location.host] || null;
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE;

const isEnabled = dsn && release && environment;

if (!isEnabled) {
  console.debug('Sentry config variables missing', {
    environment,
    dsn,
    release,
  });
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment,
  tracesSampleRate: 0.1,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  normalizeDepth: 8,
  enabled: isEnabled,
  beforeSend(event) {
    if (event.request?.status === 401) {
      return null;
    }
    return event;
  },
});
